import { useState } from "react";

const faqs = [
  {
    q: "Pourquoi combiner Lean, neurosciences et IA ?",
    a: "Le Lean optimise les flux mais ne dit rien des cerveaux qui les opèrent. Les neurosciences éclairent les résistances mais ne refont pas la chaîne. L'IA automatise mais ne change pas la culture. Les trois prises ensemble forment une grammaire complète. Chacune compense les angles morts des autres.",
  },
  {
    q: "Combien coûte le parcours DOSI-IA SHINRAI™ ?",
    a: "2\u00A0000 €\u00A0HT par mois pendant 6 mois, soit 12\u00A0000 €\u00A0HT au total. Inclut audit, accompagnement dirigeant, déploiement Lean, formation neuro, et 3 cas d'usage IA. Le ROI est généralement inférieur à 6 mois. Si ce n'est pas le cas, on en parle franchement avant de continuer.",
  },
  {
    q: "Le diagnostic gratuit, c'est vraiment gratuit ?",
    a: "Oui. 45 minutes en visio ou sur site. Pas de CB. Pas de slide. Pas d'argumentaire de vente. Tu repars avec 2-3 quick wins applicables sans nous. Si l'on est faits pour bosser ensemble, on en parle. Sinon, on te dit honnêtement vers qui aller.",
  },
  {
    q: "Vous intervenez où ?",
    a: "Partout. ShinRai opère en présentiel, en hybride et en remote — partout dans le monde. La méthode ne dépend pas du fuseau horaire, elle dépend de la volonté de transformer.",
  },
  {
    q: "L'IA, c'est pour les grandes entreprises non ?",
    a: "Non. La plupart de nos cas d'usage IA tournent dans des structures de 10 à 80 personnes. L'IA opérationnelle aujourd'hui, c'est de l'automatisation accessible : génération de devis, classification de mails, extraction de données, reporting automatisé. Les ROI sont chiffrés sous 6 mois.",
  },
  {
    q: "Combien de temps avant les premiers résultats ?",
    a: "Premiers quick wins entre la semaine 3 et la semaine 6. Effets visibles sur les indicateurs au mois 3. Transformation ancrée au mois 6. Nous ne promettons jamais de miracle au mois 1.",
  },
  {
    q: "Que se passe-t-il à la fin des 6 mois ?",
    a: "Tes équipes pilotent en autonomie. Nous sortons. Optionnellement, nous proposons un suivi trimestriel à un tarif allégé. Mais notre métier, c'est de te rendre autonome — pas de te retenir.",
  },
  {
    q: "Travaillez-vous avec mon ERP / outil ?",
    a: "Probablement oui. Nous avons intégré Cegid, Sage, Pennylane, EBP, Odoo, et des stacks plus exotiques. Nous identifions ce qui peut être automatisé sans refonte coûteuse.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState(null);
  return (
    <section id="faq" className="bg-pearl-dark py-24 sm:py-32" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="mb-16 max-w-3xl">
          <div className="font-mono-overline text-mute mb-3">Questions fréquentes</div>
          <h2 className="font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight">
            Ce que les dirigeants <em className="text-mute not-italic font-light">demandent toujours.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12">
          {faqs.map((f, i) => (
            <div key={i} className="border-b border-ink/10" data-testid={`faq-item-${i + 1}`}>
              <button
                onClick={() => setOpen(open === i ? null : i)}
                aria-expanded={open === i}
                className="faq-q"
                data-testid={`faq-question-${i + 1}`}
              >
                <span>{f.q}</span>
                <span className="faq-icon">+</span>
              </button>
              <div
                className="overflow-hidden transition-all duration-400"
                style={{ maxHeight: open === i ? "400px" : "0" }}
              >
                <p
                  className="text-mute leading-relaxed pb-6 pr-8"
                  data-testid={`faq-answer-${i + 1}`}
                >
                  {f.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
